import ApiMapper from 'constant/ApiMapper';
import { svcApi } from '.';
import axios from 'axios';

interface AccessLogsParam {
  pageSize: number;
  pageNo: number;
  searchUserNm?: string;
  searchUserId?: string;
  searchStartDt?: string;
  searchEndDt?: string;
  searchSggNm?: string;
  searchOfcNm?: string;
}

interface AccessLogsCountParam {
  searchUserNm?: string;
  searchUserId?: string;
  searchStartDt?: string;
  searchEndDt?: string;
  searchSggNm?: string;
  searchOfcNm?: string;
}

const AdminApi = {
  // 사용자 목록 조회
  getUserList: async (params: AccessLogsParam) => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.USER_LIST, {
      params: {
        pageSize: params.pageSize,
        pageNo: params.pageNo,
        searchUserNm: params.searchUserNm,
        searchUserId: params.searchUserId,
        searchDeptNm: params.searchOfcNm,
        searchSggNm: params.searchSggNm,
      },
    });

    return result.data;
  },

  // 사용자 목록 총 수 조회
  getUserListCount: async (params: AccessLogsCountParam) => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.USER_TOTAL_COUNT, {
      params: {
        searchUserNm: params.searchUserNm,
        searchUserId: params.searchUserId,
        searchDeptNm: params.searchOfcNm,
        searchSggNm: params.searchSggNm,
      },
    });

    return result.data;
  },

  // 사용자 접속 로그 리스트 조회
  getAccessLogs: async (params: AccessLogsParam) => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.LOGIN_LIST, {
      params: {
        pageSize: params.pageSize,
        pageNo: params.pageNo,
        searchUserNm: params.searchUserNm,
        searchUserId: params.searchUserId,
        searchStartDt: params.searchStartDt,
        searchEndDt: params.searchEndDt,
      },
    });

    return result.data;
  },

  // 사용자 접속 로그 리스트 총 수 조회
  getAccessLogsCount: async (params: AccessLogsCountParam) => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.LOGIN_TOTAL_COUNT, {
      params: {
        searchUserNm: params.searchUserNm,
        searchUserId: params.searchUserId,
        searchStartDt: params.searchStartDt,
        searchEndDt: params.searchEndDt,
      },
    });

    return result.data;
  },

  // 접속 로그 엑셀 다운로드
  downloadAccessLogsExcel: async (params: AccessLogsCountParam) => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.LOGIN_EXCEL_DOWNLOAD, {
      params: {
        searchUserNm: params.searchUserNm,
        searchUserId: params.searchUserId,
        searchStartDt: params.searchStartDt,
        searchEndDt: params.searchEndDt,
      },
      responseType: 'blob',
    });

    return result;
  },

  // 서비스 로그 리스트 조회
  getServiceLogs: async (params: AccessLogsParam & { searchServiceNm?: string }) => {
    const query: Record<string, any> = {
      pageSize: params.pageSize,
      pageNo: params.pageNo,
      searchUserNm: params.searchUserNm,
      searchUserId: params.searchUserId,
      searchStartDt: params.searchStartDt,
      searchEndDt: params.searchEndDt,
      searchServiceNm: (params as any).searchServiceNm,
    };
    Object.keys(query).forEach((k) => {
      const v = query[k];
      if (v === undefined || v === null || (typeof v === 'string' && v.trim() === '')) delete query[k];
    });

    const result = await svcApi.get(ApiMapper.MANAGEMENT.SERVICE_LIST, {
      params: query,
    });

    return result.data;
  },

  // 서비스 로그 리스트 총 수 조회
  getServiceLogsCount: async (params: AccessLogsCountParam & { searchServiceNm?: string }) => {
    const query: Record<string, any> = {
      searchUserNm: params.searchUserNm,
      searchUserId: params.searchUserId,
      searchStartDt: params.searchStartDt,
      searchEndDt: params.searchEndDt,
      searchServiceNm: (params as any).searchServiceNm,
    };
    Object.keys(query).forEach((k) => {
      const v = query[k];
      if (v === undefined || v === null || (typeof v === 'string' && v.trim() === '')) delete query[k];
    });

    const result = await svcApi.get(ApiMapper.MANAGEMENT.SERVICE_TOTAL_COUNT, {
      params: query,
    });

    return result.data;
  },

  // 서비스 접속 로그 엑셀 다운로드
  downloadServiceLogsExcel: async (params: AccessLogsCountParam & { searchServiceNm?: string }) => {
    const query: Record<string, any> = {
      searchUserNm: params.searchUserNm,
      searchUserId: params.searchUserId,
      searchStartDt: params.searchStartDt,
      searchEndDt: params.searchEndDt,
      searchServiceNm: (params as any).searchServiceNm,
    };
    Object.keys(query).forEach((k) => {
      const v = query[k];
      if (v === undefined || v === null || (typeof v === 'string' && v.trim() === '')) delete query[k];
    });

    const result = await svcApi.get(ApiMapper.MANAGEMENT.SERVICE_EXCEL_DOWNLOAD, {
      params: query,
      responseType: 'blob',
    });

    return result;
  },

  // 부서 SelectBox 목록 조회
  getDeptSelectBox: async () => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.GET_DEPT_LIST);

    return result.data;
  },

  // 시군구 SelectBox 목록 조회
  getSggSelectBox: async () => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.GET_SGG_LIST);

    return result.data;
  },

  // 사용자 상세 조회
  getUserDetail: (userId: string) => {
    return svcApi.get(`${ApiMapper.MANAGEMENT.USER_DETAIL}${encodeURIComponent(userId)}`);
  },

  // 사용자 비밀번호 초기화
  resetUserPassword: (userId: string) => {
    return svcApi.put(ApiMapper.MANAGEMENT.USER_PW_RESET, { userId }, { withCredentials: true });
  },

  // DOMAIN_KIND_CD 코드 목록 조회
  getDomainKindCodes: async () => {
    const result = await svcApi.get(ApiMapper.MANAGEMENT.DOMAIN_KIND_CD);

    return result.data;
  },
};

export default AdminApi;
